import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class DeviceModel extends Model 
{
	@attr name;
	@attr('boolean') shouldCreateStartRecord;
	@attr('boolean') shouldCreateFinishRecord;
	@attr('boolean') shouldCreateFinishPlungerRecord;
	@attr('boolean') shouldCreateFinishBibRecord;
	@attr('boolean') shouldCreateIntermediateTimingRecord;
	
	@belongsTo('event',{inverse: null, async: true}) EventId;
	@attr IntermediateTimingPointId;
}